var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "particpant" },
    [
      _vm.years.length
        ? _c("tenders-stat-table", {
            ref: "table",
            attrs: {
              type: "participants",
              years: _vm.years.slice().reverse(),
              stat: _vm.stat,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stat && _vm.productsStat && _vm.years.length
        ? _c("tenders-tile-charts", {
            attrs: {
              stat: _vm.stat,
              productsStat: _vm.productsStat,
              years: _vm.years,
              type: "participants",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }